import { useState } from 'react';
import { LinkIcon } from '@heroicons/react/20/solid';

import styles from './StockLevels.module.scss';
import ProductThumbnailPlaceholder from '../../../../assets/images/insights/product-thumbnail-placeholder.svg';

export const ImageField = ({ value }) => {
	const [imageError, setImageError] = useState(false);

	let imageUrl = value && Array.isArray(value) ? value[0] : value;
	if (!imageUrl || imageError) {
		imageUrl = ProductThumbnailPlaceholder;
	}

	return (
		<div className={styles.imageField}>
			<img src={imageUrl} alt="Preview" className={styles.imagePreview} onError={() => setImageError(true)} />
			<a href={imageUrl} target="_blank" rel="noopener noreferrer" className={styles.imageLink}>
				<LinkIcon />
				Image URL
			</a>
		</div>
	);
};
